import React, { useEffect, useState } from 'react';
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase";
// import '../styles/AirdropsList.scss';

export default function AirdropsList ({hideAirdropsList, airdrops}) {
	const [AirdropsList, setAirdropsList] = useState(airdrops);

	const getUsers = async () => {
		for (let airdropsID in airdrops) {
			if (!airdrops[airdropsID]['userNames']) {
				airdrops[airdropsID]['userNames'] = [];

				for (let key in airdrops[airdropsID]['users']) {
					let ref = await doc(db, "users", airdrops[airdropsID]['users'][key]);
					let snap = await getDoc(ref);
					let user = snap.data();

					if (user) {
						airdrops[airdropsID]['userNames'].push(user.firstName);
					}
				}
			}
		}
		setAirdropsList([...airdrops]);
	}

	useEffect(() => {
		getUsers();
	}, []);

	return (
		<div className="wrapper">
			<div className="modal airdrops-list-modal">
				<div className="header">
					<h2>Airdrops list</h2>
					<button className="close-button" onClick={hideAirdropsList}>
						<Cancel/>
						<span>Close</span>
					</button>
				</div>

				<div className="airdrops-list">
					{AirdropsList.length > 0 ? (
						AirdropsList.map((airdrop, airdropIndex) => (
							<div className="airdrop-item" key={airdropIndex}>
								<div className="airdrop-image">
									<img src={airdrop.image} alt={airdrop.name} />
								</div>
								<div className="airdrop-content">
									<h3 className="airdrop-name">{airdrop.name}</h3>
									<p className="airdrop-description">{airdrop.description}</p>
									{airdrop.allUsers ? (
										<p className="airdrop-users">All Users</p>
									) : airdrop.userNames ? (
										<div className="airdrop-users">
											<h4>Users:</h4>
											<ul>
												{airdrop.userNames.map((userName, userIndex) => (
													<li key={userIndex}>{userName}</li>
												))}
											</ul>
										</div>
									) : null}
								</div>
							</div>
						))
					) : (
						<div className="empty-airdrops">
							No airdrops yet
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

